import { useState, useId, type ReactNode } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

/**
 * Collapsible section with chevron
 */
export default function CollapsibleSection({
  title,
  children,
  defaultOpen = false,
  textColorClass = "text-evergreen",
}: {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  textColorClass?: string;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center gap-1 pl-0 text-left"
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <ChevronRightIcon
          className={`h-5 w-5 ${textColorClass} transition-transform ${isOpen ? "rotate-90" : ""}`}
        />
        <span className={`text-sm font-bold ${textColorClass}`}>{title}</span>
      </button>
      {isOpen && (
        <div id={contentId} className="mt-2 pl-6">
          {children}
        </div>
      )}
    </div>
  );
}
